import * as Rx from 'rxjs'
import * as log from 'loglevel'
import * as uuid from 'uuid'

import EventHub, { State } from './EventHub'

export default class EventHubKeepAlive {
  private logger = log.getLogger('EventHubKeepAliver')
  private subscription = new Rx.Subscription()
  private eventHub: EventHub
  /**
   * the idle period not seeing message from server in seconds to send a ping
   * to server
   */
  private idlePeriodToPing: number

  /**
   * how long time to reconnect if we didn't see pong from server in seconds
   */
  private reconnectDelay: number

  constructor (
    eventHub: EventHub,
    idlePeriodToPing: number,
    reconnectDelay: number = 5
  ) {
    this.eventHub = eventHub
    this.idlePeriodToPing = idlePeriodToPing
    this.reconnectDelay = reconnectDelay

    this.logger.info(
      `Init EventHubKeepAlive with idle period to ping ` +
        `${this.idlePeriodToPing}, reconnectDelay=${this.reconnectDelay}`
    )
    if (!this.idlePeriodToPing) {
      return
    }

    const messages = this.eventHub.messages.debounceTime(
      this.idlePeriodToPing * 1000
    )

    this.subscription.add(
      eventHub.state
        .switchMap(
          state =>
            state === State.Connected ? messages : Rx.Observable.never()
        )
        .switchMap(() => {
          const payload = uuid()
          this.logger.info(
            `Event hub idle ${this.idlePeriodToPing} seconds, ping ` +
              `with payload=${payload}`
          )
          const pongReceived = this.eventHub.messages
            .filter(message => {
              if (!message) {
                return false
              }
              const json = JSON.parse(message.data)
              return json.op === 'pong' && json.payload === payload
            })
            .take(1)
            .do(() => {
              this.logger.info(`Received pong for ${payload}`)
            })
          this.eventHub.ping(payload)
          return Rx.Observable
            .of(null)
            .delay(this.reconnectDelay * 1000)
            .takeUntil(pongReceived)
            .map(() => {
              return payload
            })
        })
        .subscribe(payload => {
          this.logger.info(
            `Didn't see pong for ${payload} for ` +
              `${this.reconnectDelay}, reconnect`
          )
          // reconnect
          this.eventHub.disconnect()
          this.eventHub.connect()
        })
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/io/event-hub/EventHubKeepAlive.ts